module.exports = __webpack_public_path__ + "img/4.55feef4d.jpg";